import {
	KnowledgeDiscoveryJiraSearchClassification,
	type KnowledgeDiscoveryJiraIntentDetectionModelType,
	type KnowledgeDiscoveryJiraSearchClassificationType,
} from '@atlassian/search-client/knowledge-discovery/types';

import { disposableValue } from './disposable-value';

// oxlint-disable-next-line eslint/no-redeclare
export const IntentMode: {
	readonly GNIN: 'GNIN';
	readonly FPS: 'FPS';
} = KnowledgeDiscoveryJiraSearchClassification;

export type IntentMode = KnowledgeDiscoveryJiraSearchClassificationType;

export type IntentDetection = {
	mode: IntentMode;
	query: string;
	route: string;
	modelId: KnowledgeDiscoveryJiraIntentDetectionModelType;
	patternType?: string;
};

export const INTENT_DETECTION: import('./disposable-value').DisposableValue<IntentDetection | null> =
	disposableValue<IntentDetection | null>(null);

/**
 * Known values for the `patternType` field returned by the intent-detection
 */
export const PatternType = {
	Jql: 'JQL',
} as const;

/**
 * `true` when the most recent intent-detection response classified the
 * provided query as a typed JQL expression.
 */
export const isJqlQueryDetected = (currentQuery: string): boolean => {
	const stored = INTENT_DETECTION.value();
	if (!stored || stored.patternType !== PatternType.Jql) {
		return false;
	}
	return stored.query.trim() === currentQuery.trim();
};
